import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'

Vue.use(Vuex)



// modulesFiles 函数  通过模块路劲地址返回模块对象
// modulesFiles.keys 函数  返回模块路劲地址
// modulesFiles.resolve 函数
// modulesFiles.id
//类似 require单个引入
// https://webpack.js.org/guides/dependency-management/#requirecontext
// you do not need `import app from './modules/app'`
// it will auto require all vuex module from modules file
const modulesFiles = require.context('./modules', true, /\.js$/)
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  // set './app.js' => 'app'
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  return modules
}, {})
const store = new Vuex.Store({
  modules,
  getters
})
export default store
